import { Component } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent {
  now: Date = new Date();

  // Data oficial do Dia de Doar 2026: 01/12/2026
  // O mês 11 representa dezembro, porque no JavaScript os meses começam em 0.
  date: Date = new Date(2026, 11, 1);

  get timeDiff(){
    return this.date.getTime() - this.now.getTime();
  }

  get daysTo(){
    return Math.floor(this.timeDiff/(1000*60*60*24))
  }

  get hoursTo(){
    return Math.floor((this.timeDiff%(1000*60*60*24))/(1000*60*60))
  }

  get minutesTo(){
    return Math.floor((this.timeDiff%(1000*60*60))/(1000*60))
  }
}